import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../config";
import cogoToast from "cogo-toast";

// ================================================================= GET BET CATEGORIES

export const getBetCategories = createAsyncThunk(
  "getBetCategories",
  async (arg, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await axios.get(`${baseUrl}/bet/bet-categories`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to fetch categories");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= GET BET QUESTIONS BY CATEGORY

export const getBetQuestions = createAsyncThunk(
  "getBetQuestions",
  async ({ category_id = 0, page = 0, per_page = 10 }, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await axios.get(`${baseUrl}/bet/bet-questions?category_id=${category_id}&page=${page}&per_page=${per_page}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to fetch questions");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= PLACE BET

export const placeBet = createAsyncThunk(
  "placeBet",
  async ({ questionId, optionId, transactionPin, walletId, amount }, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/bet/${userId}`,
        {
          questionId,
          optionId,
          transactionPin,
          walletId,
          amount
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      
      if (res.status === 200 || res.status === 201) {
        cogoToast.success("Bet placed successfully!");
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        const errorMessage = error.response?.data?.message || "Failed to place bet";
        cogoToast.error(errorMessage);
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= GET USER BETS

export const getUserBets = createAsyncThunk(
  "getUserBets",
  async ({ status = 'ACTIVE', page = 0, per_page = 10 }, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.get(`${baseUrl}/bet/users/${userId}?status=${status}&page=${page}&per_page=${per_page}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to fetch user bets");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= CASHOUT BET

export const cashoutBet = createAsyncThunk(
  "cashoutBet",
  async ({ betId }, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.patch(`${baseUrl}/bet/accept-cashout/${userId}`, {
        betId
      }, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      
      if (res.status === 200 || res.status === 201) {
        cogoToast.success("Bet cashed out successfully!");
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        const errorMessage = error.response?.data?.message || "Failed to cashout bet";
        cogoToast.error(errorMessage);
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= GET QUESTION DETAILS

export const getQuestionDetails = createAsyncThunk(
  "getQuestionDetails",
  async ({ id}, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await axios.get(`${baseUrl}/bet/bet-questions/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to fetch question details");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= GET RELATED MARKETS

export const getRelatedMarkets = createAsyncThunk(
  "prediqo/getRelatedMarkets",
  async ({ bet_category_id }, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await axios.get(`${baseUrl}/bet/related-markets/${bet_category_id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });

      if (res.status === 200) {
        console.log(res.data)
        return res.data;
      }
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to fetch related markets");
        return rejectWithValue(error.response);
      }
    }
  }
);
  